'use client'
import type { FC, ReactNode } from 'react'
import { customTheme } from '#/src/custom/styles/theme'
import { ChakraProvider } from '@chakra-ui/react'
import { EmotionRegistry } from 'ui/lib/emotion-registry/EmotionRegistry'
import { SetInitialColorMode } from 'ui/storefront'

interface ChakraProviderNextProps {
  children: ReactNode
}

const ChakraProviderNext: FC<ChakraProviderNextProps> = ({ children }) => {
  return (
    <EmotionRegistry>
      <ChakraProvider resetCSS theme={customTheme}>
        <SetInitialColorMode
          initialColorMode={
            customTheme.config.initialColorMode === 'system'
              ? 'light'
              : customTheme.config.initialColorMode
          }
        />
        {children}
      </ChakraProvider>
    </EmotionRegistry>
  )
}

export default ChakraProviderNext
